module.exports = __webpack_public_path__ + "img/ford-service.98ce130a.png";